import { noop } from "lodash-es"
import { createContext, useContext } from "react"
import { AccordionContextValue, AccordionItemContextValue } from "./types"

export const AccordionItemContext = createContext<AccordionItemContextValue>({
  id: undefined,
  containerId: undefined,
  buttonId: undefined,
  isExpanded: false,
})

export const useAccordionItemContext = () => useContext(AccordionItemContext)

export const AccordionContext = createContext<AccordionContextValue>({
  open: [],
  toggleOpen: noop,
})
export const useAccordionContext = () => useContext(AccordionContext)
